import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";

import LargeItemStatus from "../../../../../../common/components/large_item_status";
import dataUtils from "../../../../../../common/utils/dataUtils";
import DynamicIcon from "../../../../../../components/global/DynamicIcon";

/**
 * GenerateObrasColumnDefinition
 */

type Props = {
  onActionViewItem: (idChecklist: number | null, openNewTab: boolean) => void;
  onActionEditar: (idEquipMedicao: number | null, openState: boolean) => void;
  onActionDeletar: (idEquipMedicao: number | null, openState: boolean) => void;
};

export const GenerateControlePatrimonioColumnDefinition = ({
  onActionEditar,
  onActionDeletar,
  onActionViewItem,
}: Props): GridColDef[] => {
  //#region  Tipo
  const computeItemTipoTitle = (tipo: boolean) => {
    switch (tipo) {
      case false:
        return "Inativo";
      case true:
        return "Ativo";
      default:
        return "?";
    }
  };
  const computeItemTipoColor = (tipo: boolean) => {
    switch (tipo) {
      case false:
        return "red";
      default:
        return "blue";
    }
  };

  //#endregion

  return [
    {
      field: "ativo",
      filterable: false,
      headerName: "Status",
      minWidth: 100,
      width: 100,
      sortable: false,
      renderCell: (params) => (
        <div className="w-[5rem] h-full flex justify-center items-center">
          <LargeItemStatus
            title={computeItemTipoTitle(params.value)}
            color={computeItemTipoColor(params.value)}
            description={computeItemTipoTitle(params.value)}
          />
        </div>
      ),
    },
    {
      field: "codigo",
      filterable: false,
      headerName: "Código",
      minWidth: 100,
      sortable: false,
      headerClassName: "equipamento-header",
    },
    {
      field: "quantidade",
      filterable: false,
      headerName: "Quantidade",
      minWidth: 100,
      sortable: false,
      headerClassName: "responsavelPeloEquipamento-header",
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Nome da Máquina ou Equipamento",
      flex: 1,
      minWidth: 300,
      sortable: false,
      headerClassName: "responsavelPeloEquipamento-header",
    },
    {
      field: "centroCusto",
      filterable: false,
      headerName: "Centro de Custo",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: "responsavelPeloEquipamento-header",
    },
    {
      field: "localizacao",
      filterable: false,
      headerName: "Localização",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: "responsavelPeloEquipamento-header",
    },
    {
      field: "dataCadastro",
      filterable: false,
      headerName: "Data de Cadastro",
      minWidth: 100,
      flex: 1,
      sortable: false,
      valueGetter: (value) => {
        return dataUtils.dataFormatada(value ? value : null);
      },
      headerClassName: "usuarios-header",
    },
    {
      field: "idMaquinaEquip",
      headerName: "Ações",
      sortable: false,
      filterable: false,
      width: 100,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.row.idMaquinaEquip, true)}>
            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
          </IconButton>

          <IconButton onClick={() => onActionDeletar(params.row.idMaquinaEquip, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
    {
      field: "itens",
      filterable: false,
      headerName: "Itens",
      sortable: false,
      width: 90,
      minWidth: 90,
      valueGetter: (_, row) => {
        return row["idMaquinaEquip"] as number;
      },
      renderCell: ({ value }) => {
        return (
          <Button
            onMouseDown={(e) => {
              if (e.button === 1) {
                onActionViewItem(value, true);
              } else {
                onActionViewItem(value, e.ctrlKey);
              }
              e.preventDefault();
            }}
            sx={{
              fontSize: 11,
              paddingX: ".4rem",
              paddingY: 0,
              background: "#e6e6e6",
              borderLeft: ".2rem solid #8e44ad",
              borderRadius: 0,
              color: "black",
              fontWeight: "normal",
            }}>
            Itens
          </Button>
        );
      },
    },
  ];
};
